/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * One event exposed to self-serve authoring for this game. Carries exposure and this game's wording — NOT scoring. Points belong to the competition, which is where the weight is actually decided.
 * @export
 * @interface ExternalEventAllowlistEntry
 */
export interface ExternalEventAllowlistEntry {
    /**
     * The EventType this entry exposes.
     * @type {string}
     * @memberof ExternalEventAllowlistEntry
     */
    eventTypeId: string;
    /**
     * Friendly name shown to a self-serve author, in this game's vernacular. Never an id.
     * @type {string}
     * @memberof ExternalEventAllowlistEntry
     */
    label: string;
    /**
     * Hide without losing the curated label. Defaults true.
     * @type {boolean}
     * @memberof ExternalEventAllowlistEntry
     */
    enabled?: boolean;
}

/**
 * Check if a given object implements the ExternalEventAllowlistEntry interface.
 */
export function instanceOfExternalEventAllowlistEntry(value: object): value is ExternalEventAllowlistEntry {
    if (!('eventTypeId' in value) || value['eventTypeId'] === undefined) return false;
    if (!('label' in value) || value['label'] === undefined) return false;
    return true;
}

export function ExternalEventAllowlistEntryFromJSON(json: any): ExternalEventAllowlistEntry {
    return ExternalEventAllowlistEntryFromJSONTyped(json, false);
}

export function ExternalEventAllowlistEntryFromJSONTyped(json: any, ignoreDiscriminator: boolean): ExternalEventAllowlistEntry {
    if (json == null) {
        return json;
    }
    return {
        
        'eventTypeId': json['eventTypeId'],
        'label': json['label'],
        'enabled': json['enabled'] == null ? undefined : json['enabled'],
    };
}

export function ExternalEventAllowlistEntryToJSON(json: any): ExternalEventAllowlistEntry {
    return ExternalEventAllowlistEntryToJSONTyped(json, false);
}

export function ExternalEventAllowlistEntryToJSONTyped(value?: ExternalEventAllowlistEntry | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'eventTypeId': value['eventTypeId'],
        'label': value['label'],
        'enabled': value['enabled'],
    };
}

